<script lang="ts">
    export let title: string;
    export let imageWidth: string;
    export let imageSrc: string;
</script>

<div
    class="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center"
>
    <div class="relative">
        <h3
            class="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl"
        >
            {title}
        </h3>
        <slot />
    </div>

    <div class="mt-10 -mx-4 relative lg:mt-0 px-4" aria-hidden="true">
        <img
            class="relative mx-auto rounded-lg"
            width={imageWidth}
            src={imageSrc}
            alt=""
        />
    </div>
</div>
